import { Controller } from "@hotwired/stimulus";

// Toggles the PAXG transaction fee fields based on the selected kind: buy and
// sell can both carry an optional fee (in either currency, see
// Forms::Investments::PaxgTransaction), opening balance has none. qty and
// eur_amount are always shown.
export default class extends Controller {
  static targets = ["kindSelect", "feeField"];

  connect() {
    this.toggle();
  }

  toggle() {
    const kind = this.kindSelectTarget.value;

    this.feeFieldTargets.forEach((field) => field.classList.toggle("d-none", kind === "opening_balance"));
  }
}
